import wx from 'weixin-js-sdk'
/**
 * 通用工具类
 */

/**
 * window对象
 */
const win = {
  getLocation: function () {
    return window.location
  }
}

/**
 * 从URL中获取query参数的值
 * @param  {String}  name         [query键]
 * @param  {Boolean} isBase64     [是否要做base64解密]
 * @return {String}               [query值]
 */
function getQueryString (name, isBase64) {
  const reg = new RegExp('(^|&)' + name + '=([^&|^#]*)(&|#|$)', 'i')
  const winLocation = win.getLocation()
  if (!(winLocation.href.indexOf('?') > -1)) {
    return null
  }
  const r = winLocation.href.split('?')[1].match(reg)
  if (r != null) {
    if (isBase64) {
      let utf8Str = ''
      try {
        utf8Str = window.atob(decodeURIComponent(r[2]))
      } catch (e) {
        // alert(e)
      }
      return decodeURIComponent(utf8Str)
    } else {
      return decodeURIComponent(r[2])
    }
  }
  return null
}

/**
 * 根据json获取session
 * @return {Object} [session]
 */
function getSession () {
  let session = null
  const winLocation = win.getLocation()
  const sessionJson = getQueryString('json', true, winLocation)
  if (sessionJson) {
    session = JSON.parse(sessionJson)
    // 设置sessionStorage
    if (session && window.sessionStorage) {
      sessionStorage.setItem('tk', session.token)
      sessionStorage.setItem('customerId', session.customerId)
      sessionStorage.setItem('customerName', session.customerName)
      sessionStorage.setItem('userId', session.userId)
      sessionStorage.setItem('coreCustomers', JSON.stringify(session.coreCustomers))
    }
  }

  return session
}

/**
 * 根据环境获取 HOME 地址
 * @return {String} [HOME 地址]
 */
function getHomeHostUrl () {
  let url = 'https://www.iqunxing.com'
  let protocal = 'http://'
  const hostname = win.getLocation().hostname
  const subDomain = hostname.split('.')[0]

  if (subDomain === 'www' ||
      subDomain === 'wuat' ||
      subDomain === 'wuat-3' ||
      subDomain === 'whotfix' ||
      subDomain === 'demo') {
    protocal = 'https://'
  }

  if (hostname === 'localhost') {
    url = win.getLocation().origin
  } else if (subDomain === 'www') {
    url = protocal + 'home.iqunxing.com'
  } else if (subDomain === 'test1') {
    url = protocal + 'test1.iqunxing.com'
  } else if (subDomain === 'demo') {
    url = protocal + 'demoh.iqunxing.com'
  } else if (subDomain === 'wuat' || subDomain === 'whotfix' || subDomain === 'wuat-3') {
    const env = subDomain.substring(1, subDomain.length)
    const hostTarget = 'h' + env
    url = protocal + hostTarget + '.dcfservice.com'
  } else if (subDomain.indexOf('wt') === 0) {
    const env = subDomain.substring(1, subDomain.length)
    const hostTarget = 'h' + env
    url = protocal + hostTarget + '.dcfservice.com'
  }

  return url
}

/**
 * 数组是否包含某一值
 * @param  {Array}  array [数组]
 * @param  {[Object]} val [值]
 * @return {[boolean]}    [是否包含]
 */
function isArrayContains (array, val) {
  if (array && array.length > 0) {
    for (let i = 0; i < array.length; i++) {
      if (array[i] === val) {
        return true
      }
    }
  }

  return false
}

// pick a random number within a range of numbers
// int b rand(int a); where 0 <= b <= a
function rand (max) {
  return Math.floor(Math.random() * (max + 1))
}

// Replaced from the original function to leverage the built in methods in
// JavaScript. Thanks to Robert Kieffer for pointing this one out
function returnBase (number, base) {
  return (number).toString(base).toUpperCase()
}

// Pull out only certain bits from a very large integer, used to get the time
// code information for the first part of a UUID. Will return zero's if there
// aren't enough bits to shift where it needs to.
function getIntegerBits (val, start, end) {
  const base16 = returnBase(val, 16)
  const quadArray = []
  var quadString = ''
  var i = 0
  for (i = 0; i < base16.length; i++) {
    quadArray.push(base16.substring(i, i + 1))
  }

  for (i = Math.floor(start / 4); i <= Math.floor(end / 4); i++) {
    if (!quadArray[i] || quadArray[i] === '') quadString += '0'
    else quadString += quadArray[i]
  }

  return quadString
}

/**
 * 生成UUID
 * @return {[type]} [description]
 */
function createUUID () {
  // Loose interpretation of the specification DCE 1.1: Remote Procedure Call
  // since JavaScript doesn't allow access to internal systems, the last 48 bits
  // of the node section is made up using a series of random numbers (6 octets long).
  const dg = new Date(1582, 10, 15, 0, 0, 0, 0)
  const dc = new Date()
  const t = dc.getTime() - dg.getTime()
  const tl = getIntegerBits(t, 0, 31)
  const tm = getIntegerBits(t, 32, 47)
  const thv = getIntegerBits(t, 48, 59) + '1' // version 1, security version is 2
  const csar = getIntegerBits(rand(4095), 0, 7)
  const csl = getIntegerBits(rand(4095), 0, 7)

  // since detection of anything about the machine/browser is far to buggy,
  // include some more random numbers here
  // if NIC or an IP can be obtained reliably, that should be put in
  // here instead.
  const n = getIntegerBits(rand(8191), 0, 7) +
          getIntegerBits(rand(8191), 8, 15) +
          getIntegerBits(rand(8191), 0, 7) +
          getIntegerBits(rand(8191), 8, 15) +
          getIntegerBits(rand(8191), 0, 15) // this last number is two octets long
  return tl + tm + thv + csar + csl + n
}

/**
 * 检测是否手机端
 * @return [Boolean]
 */
function ismobile () {
  const winWidth = window.innerWidth || document.body.clientWidth
  return winWidth && winWidth < 736
}

/**
 * 判断是否是qq自带浏览器
 * @return [Boolean]
 */
function isQQBrowser () {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('qq') > -1 && ua.indexOf('mqqbrowser') < 0) {
    return true
  }
  return false
}

/**
 * 检测是否设备类型
 * @ [https://github.com/matthewhudson/device.js/blob/master/lib/device.js]
 */
function device () {
  var device, find, userAgent
  device = {}
  userAgent = window.navigator.userAgent.toLowerCase()

  device.ios = function () {
    return device.iphone() || device.ipod() || device.ipad()
  }

  device.iphone = function () {
    return !device.windows() && find('iphone')
  }

  device.ipad = function () {
    return find('ipad')
  }

  device.ipod = function () {
    return find('ipod')
  }

  device.android = function () {
    return !device.windows() && find('android')
  }

  device.weixin = function () {
    return !device.windows() && find('micromessenger')
  }

  device.windows = function () {
    return find('windows')
  }

  find = function (needle) {
    return userAgent.indexOf(needle) !== -1
  }
  return device
}

/**
 * base64编码
 * @param utf8
 * @returns {string}
 */
function utf8ToBase64 (utf8) {
  return window.btoa(encodeURIComponent(utf8))
}

/**
 * base64解码
 * @param base64
 * @returns {string}
 */
function base64ToUtf8 (base64) {
  return decodeURIComponent(window.atob(base64).replace('+', '%20'))
}

/*
* 检测是否是正确的手机号
* @param phone number
* @returns {boolean}
*/
function isCellphone (number) {
  const reg = /^1\d{10}$/
  return reg.test(number)
}

/*
* 检测是否是正确的邮箱
* @param email
* @returns {boolean}
*/
function isMail (email) {
  const reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
  return reg.test(email)
}

/*
* 获取手机app下载地址
* @param vue实例
* @returns 无
*/
function getAPPUrl (vm) {
  if (device().weixin()) {
    vm.appUrl = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.dcf.qxapp'
  } else if (device().ios()) {
    vm.appUrl = 'https://itunes.apple.com/cn/app/id946253851'
  } else {
    vm.ajax({
      type: 'POST',
      url: 'https://www.iqunxing.com/mapi/corpversion@getLastVersion@v1',
      data: {
        content: {
          clientCode: 'ACBF12F9F7',
          terminalCode: 'TBF12F9F9',
          channelCode: 'CH573DF4B7'
        }
      },
      contentType: 'application/json',
      success (res) {
        const content = JSON.parse(res.data.content)
        vm.appUrl = content.appURL
      }
    })
  }
}

/*
* 判断是否是微信
* @param vue实例
* @returns {boolean}
*/
function isWechat () {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('micromessenger') > -1) {
    return true
  } else {
    return false
  }
}

/*
* 微信分享功能
* @param vue实例
* @returns
*/
function initWechat (vm, logoUrl, title, desc) {
  if (!isWechat()) {
    return
  }
  var nonceStr = 'abcdefg'
  var timestamp = new Date().getTime().toString().substring(0, 10)
  var locationUrl = location.href
  var shareLogo = logoUrl || ''

  vm.ajax({
    url: '/services/public/mobile/getSignature',
    type: 'POST',
    data: {
      nonceStr: nonceStr,
      timestamp: timestamp,
      url: locationUrl
    },
    success (resp) {
      wx.config({
        debug: false,
        appId: 'wx5b8b94317c7511eb',
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: resp.data.result.signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
      })
    }
  })
  wx.ready(function () {
    var link = locationUrl
    wx.onMenuShareTimeline({
      title: title || '群星',
      desc: desc || '',
      link: link,
      imgUrl: shareLogo,
      success: function () {
        console.log('成功')
      }
    })
    wx.onMenuShareAppMessage({
      title: title || '群星',
      desc: desc || '',
      link: link,
      imgUrl: shareLogo,
      success: function () {
        console.log('成功')
      }
    })
  })
}
// 获取主域名
function getMainDomain () {
  let mainDomain = null
  const hostName = location.hostname
  const domainSplit = hostName.split('.')
  if (domainSplit.length >= 3) {
    var sectionList = []
    var skipStep = domainSplit.length - 2
    for (var i = skipStep; i < domainSplit.length; i++) {
      sectionList.push(domainSplit[i])
    }

    mainDomain = sectionList.join('.')
  } else {
    mainDomain = 'localhost'
  }

  return mainDomain
}

export { win, getSession, getQueryString, isArrayContains, getHomeHostUrl, createUUID, ismobile, isQQBrowser, device, utf8ToBase64, base64ToUtf8, isCellphone, isMail, getAPPUrl, initWechat, getMainDomain }



// WEBPACK FOOTER //
// ./src/assets/js/CommonUtils.js